import React from 'react';

/**
 * Metric tile matching the Statistics "Key metrics" layout: label + value + optional footer, large faded icon on the right.
 *
 * @param {string} props.label
 * @param {React.ReactNode} props.value - Main number or text
 * @param {React.ReactNode} props.icon - Typically lucide icon with w-12 h-12, semantic colour, opacity-20
 * @param {React.ReactNode} [props.footer] - e.g. trend row or action link
 */
export function KeyMetricCard({ label, value, icon, footer }: any) {
  return (
    <div className="card-mdl-static-interactive overflow-hidden">
      <div className="p-5">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-slate-400">{label}</p>
            <p className="text-2xl font-semibold text-slate-100 mt-1 tabular-nums">{value}</p>
            {footer ? <div className="mt-2">{footer}</div> : null}
          </div>
          <div className="flex-shrink-0 pointer-events-none" aria-hidden>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KeyMetricCard;
